import { render, staticRenderFns } from "./manageDiscounts.vue?vue&type=template&id=18c1d1c2&scoped=true"
import script from "./manageDiscounts.vue?vue&type=script&lang=js"
export * from "./manageDiscounts.vue?vue&type=script&lang=js"
import style0 from "./manageDiscounts.vue?vue&type=style&index=0&id=18c1d1c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c1d1c2",
  null
  
)

export default component.exports